import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAdsenseIfConsented } from "./lib/loadAdsense";

initAdsenseIfConsented();

createRoot(document.getElementById("root")!).render(<App />);
